//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import {getUrlparams,countDownTimeFunc} from '@/utils/util.js'
import footerNav from '@/components/footerNav'
import { Dialog,Toast } from 'vant';

export default {
  name: "refundOrder",
  components: {
    footerNav
  },
  data() {
    return {
      value:''
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    onSearch(){
    },
    toDetail(){
      this.$router.push({name:'refundOrderDetail'})
    },
    clickBtn(){
      Dialog.confirm({
        title: '提示',
        message: '确认进行此操作',
      })
        .then(() => {
          Toast.success('成功');

        })
        .catch(() => {
          Toast.fail('已取消');
        });
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/refundOrder/index.vue